import React from 'react';
import { formatCurrency } from '@app/shared/lib/formatting';

interface Props {
    amount: string;
}
export function CurrencyFormatter(props: Props) {
    return <span>{formatCurrency(props.amount)}</span>;
}
